import React, { FC } from 'react';
import { useTruckerNavigation } from 'hooks/useNavigation';
import * as Styled from './styled';
import { TextLinkProps } from './types';

const TextLink: FC<TextLinkProps> = ({ label, link, externalRoute = false, fontWeight }) => {
  const { handleNavigation } = useTruckerNavigation();

  const handleNavigate = () => {
    /* istanbul ignore else */
    if (externalRoute) {
      window.open(link, '_blank');
      return;
    }
    handleNavigation(link);
  };

  return (
    <Styled.Link onClick={handleNavigate} fontWeight={fontWeight}>
      {label}
    </Styled.Link>
  );
};

export default TextLink;
